import { Link } from "react-router-dom";
import Logo from "../../assets/logo-transparent.png";
import styles from "./Footer.module.css";

const Footer = () => {
  const date = new Date().getFullYear();

  return (
    <div>
      <div className={styles.footerContainer}>
        <div className="section">
          <div className={styles.footerSection}>
            <div className={styles.footerLogo}>
              <img src={Logo} alt="Logo" width={40} />
              <span>APEI</span>
            </div>
            {/* <div className={styles.footerLinks}>
              <div className={styles.ourLinks}>Links</div>
              <Link className={styles.link} to="/">
                Home
              </Link>
              <Link className={styles.link} to="/courses">
                Courses
              </Link>
              <Link className={styles.link} to="/contact">
                Contact&nbsp;us
              </Link>
            </div> */}
          </div>
          <div className={styles.rights}>
            © {date} <span>APEI</span>. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
